// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Finances20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Finances20: FC<Finances20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M4 14.5V8h1.5v6.5H4Zm5.25 0V8h1.5v6.5h-1.5ZM2 17v-1.5h16V17H2Zm12.5-2.5V8H16v6.5h-1.5ZM2 7V5l8-4 8 4v2H2Zm2.354-1.5h11.292L10 2.687 4.354 5.5Z" />
        </svg>
    );
};

export default Finances20;
